import React from 'react'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { Box } from 'transfix-ui/core'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { TQuoteFilters } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/types'
import { AlertIcon } from 'transfix-icons'
import { Switch } from 'transfix-ui'

const useStyles = makeStyles(theme => ({
  filterRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    marginBottom: theme.spacing(1.5),
  },
  testQuoteParent: {
    display: 'flex',
    alignItems: 'center',
  },
  alertIcon: { marginTop: '5px', marginLeft: '3px' },
}))

interface ITestQuoteFilterProps {
  isTestQuote: boolean
  setQuotesFilters: (value: React.SetStateAction<TQuoteFilters>) => void
  quotesFilters: TQuoteFilters
}

export const TestQuoteFilter = ({
  isTestQuote,
  quotesFilters,
  setQuotesFilters,
}: ITestQuoteFilterProps) => {
  const classes = useStyles()

  const toggleTestQuoteHandler = () => {
    const newTestQuote = !quotesFilters.isTestQuote
    setQuotesFilters({ ...quotesFilters, isTestQuote: newTestQuote })
  }

  return (
    <Box ml='18px' className={classes.filterRow}>
      <Switch
        dataTest='is-test-quote-switch'
        checked={isTestQuote}
        onChange={toggleTestQuoteHandler}
        label={
          <div className={classes.testQuoteParent}>
            Show Test Quotes
            <Tooltip
              trigger={
                <span className={classes.alertIcon}>
                  <AlertIcon />
                </span>
              }>
              When toggled on, test quotes will be included in results
            </Tooltip>
          </div>
        }
      />
    </Box>
  )
}
